import React from 'react';
import PropTypes from 'prop-types';

import { useInterviewApi } from './EmployerV1/hooks';

import CompanyName from './components/CompanyName';
import QuestionForm from './EmployerV1/components/QuestionForm';

export function EmployerScreeningQuestionsApp({ encResponseId, isMobile, onCompleted, setIsLoading }) {
  const {
    clearErrorMessage,
    data,
    errorMessage,
    handleContinue,
    handleSkip,
  } = useInterviewApi(encResponseId);

  if (data.completed) {
    onCompleted();
    return null;
  }

  if (!data.questions) {
    return null;
  }

  const uploadParameters = {
    extensions: data.answer_upload_extensions,
    max_bytes: data.answer_upload_max_bytes,
    max_bytes_string: data.answer_upload_max_bytes_string,
    types: data.answer_upload_types,
  };

  const question = { ...data.questions[0], uploadParameters };

  return (
    <div>
      <CompanyName companyName={data.quiz.hiring_company_name} />
      <QuestionForm
        clearErrorMessage={clearErrorMessage}
        errorMessage={errorMessage}
        isMobile={isMobile}
        onContinue={handleContinue}
        onSkip={handleSkip}
        question={question}
        showProfileWarning={data.show_profile_warning}
        totalQuestions={data.quiz_total_questions}
        setIsLoading={setIsLoading}
      />
    </div>
  );
}

EmployerScreeningQuestionsApp.propTypes = {
  encResponseId: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  onCompleted: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func,
};

EmployerScreeningQuestionsApp.defaultProps = {
  isMobile: false,
  setIsLoading: () => {},
};

export default EmployerScreeningQuestionsApp;
